import { HttpError } from "@tomra/client-side-http-client";
import { authenticatedFetch } from "$lib/authenticatedFetch";
import { API_HOST } from "$lib/environment";
import { diffState, diffSummary } from "$lib/stores/masterdataStore";
import { errorDetails, errorState } from "$lib/stores/errorState";

const parseErrorResponse = async (response: Response): Promise<HttpError> => {
  let body: string | Record<string, unknown> = response.statusText;
  try {
    body = await response.json();
  } catch {
    // Body wasn't JSON, use statusText
  }
  return new HttpError(response.status, response.statusText, body);
};

export const fetchDiff = async (fromData: FormData) => {
  diffState.set("Loading");
  try {
    const response = await authenticatedFetch(`${API_HOST}/import`, {
      method: "POST",
      body: fromData,
    });
    if (!response.ok) {
      setErrorState(await parseErrorResponse(response));
      diffState.set("Idle");
      return;
    }
    const json = await response.json();

    setOkState();
    diffSummary.set(json.data);
  } catch (e: Error | unknown) {
    setErrorState(e);
    diffState.set("Idle");
  }
};

export const applyDiff = async (
  sourceSystem: string,
  diffId: string,
  originatingEnv: string,
) => {
  try {
    const url = `${API_HOST}/source-system/${sourceSystem}/diff/${diffId}?originatingEnv=${encodeURIComponent(originatingEnv)}`;
    const response = await authenticatedFetch(url, { method: "POST" });
    if (!response.ok) {
      setErrorState(await parseErrorResponse(response));
      return false;
    }
    setOkState();
    return true;
  } catch (e: Error | unknown) {
    setErrorState(e);
    return false;
  }
};

export const deleteDiff = async (
  sourceSystem: string,
  diffId: string,
  originatingEnv: string,
) => {
  try {
    const response = await deleteDiffNoSideEffects(
      sourceSystem,
      diffId,
      originatingEnv,
    );
    if (!response.ok) {
      setErrorState(await parseErrorResponse(response));
      return false;
    }
    setOkState();
    diffSummary.set(null);
    return true;
  } catch (e: Error | unknown) {
    setErrorState(e);
    return false;
  }
};

export const deleteDiffNoSideEffects = async (
  sourceSystem: string,
  diffId: string,
  originatingEnv: string,
) => {
  const url = `${API_HOST}/source-system/${sourceSystem}/diff/${diffId}?originatingEnv=${encodeURIComponent(originatingEnv)}`;
  return await authenticatedFetch(url, { method: "DELETE" });
};

const setOkState = () => {
  errorDetails.set(null);
  diffState.set("Ready");
  errorState.set("OK");
};

const setErrorState = (e: Error | unknown) => {
  errorState.set("Error");
  errorDetails.set(e);
};
